import { Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { Article } from './article.component';
import { Illustration } from './illustration/illustration.component';

const elements = {
	container: styled.div`
		display: flex;
		flex-direction: column;
		margin: 0 auto;
		gap: ${tokens.spacing.x2};
		max-width: 100%;
		width: 480px;
		align-items: center;
		flex-grow: 1;
	`,
	illustration: styled.div`
		max-width: 320px;
	`,
	content: styled.div`
		display: flex;
		flex-direction: column;
		width: 100%;
		gap: ${tokens.spacing.x2};
		flex-grow: 1;
	`,
	contentTop: styled.div`
		display: flex;
		flex-direction: column;
		gap: ${tokens.spacing.x2};
		flex-grow: 1;

		${tokens.breakpointQuery.small} {
			flex-grow: 0;
		}
	`,
	contentBottom: styled.div`
		display: flex;
		flex-direction: column;

		${tokens.breakpointQuery.small} {
			flex-direction: row;
		}
	`,
};

interface ErrorInterruptedProps {
	children?: ReactNode;
	title: string;
	body: string;
}

export function ErrorInterrupted({ children, title, body }: ErrorInterruptedProps) {
	return (
		<elements.container>
			<elements.illustration>
				<Illustration type='error' />
			</elements.illustration>
			<elements.content>
				<elements.contentTop>
					<Text.h1 variant='headingMedium'>{title}</Text.h1>
					<Article>{body}</Article>
				</elements.contentTop>

				{children ? <elements.contentBottom>{children}</elements.contentBottom> : null}
			</elements.content>
		</elements.container>
	);
}
